export const FETCH_WORKS_TO_IMPORT = 'IMPORT/WORKS/SEARCH/REQUEST';
export const FETCH_WORKS_TO_IMPORT_SUCCESS = 'IMPORT/WORKS/SEARCH/SUCCESS';
